import script from "./CustomerDistributionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerDistributionModal.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerDistributionModal.vue?vue&type=style&index=0&id=6d3b0680&lang=scss"

const __exports__ = script;

export default __exports__